"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Bitmoji3DImage = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const Bitmoji3DImage_module_css_1 = __importDefault(require("./Bitmoji3DImage.module.css"));
const WebPImage_1 = require("../Images/WebPImage");
/**
 * User 3D bitmoji image
 * Renders the avatar and background image together
 */
function Bitmoji3DImage({ avatarUrl, avatarFallbackUrl, backgroundUrl, backgroundFallbackUrl, borderRadiusAsString, avatarAlt, backgroundAlt, }) {
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("div", { className: `${Bitmoji3DImage_module_css_1.default.webPImageWrapper} ${Bitmoji3DImage_module_css_1.default.avatarImageStyle}`, children: (0, jsx_runtime_1.jsx)(WebPImage_1.WebPImage, { url: avatarUrl, fallbackUrl: avatarFallbackUrl, alt: avatarAlt, objectFit: "cover", borderRadiusAsString: borderRadiusAsString }) }), (0, jsx_runtime_1.jsx)("div", { className: Bitmoji3DImage_module_css_1.default.webPImageWrapper, children: (0, jsx_runtime_1.jsx)(WebPImage_1.WebPImage, { url: backgroundUrl, fallbackUrl: backgroundFallbackUrl, alt: backgroundAlt, objectFit: "cover", borderRadiusAsString: borderRadiusAsString }) })] }));
}
exports.Bitmoji3DImage = Bitmoji3DImage;
//# sourceMappingURL=index.js.map